// 资料管理
import MaterialIndex from './material/Index';
import MyMaterialIndex from './material/myMaterical/Index';
import DocumentAdd from './material/document/PageAdd';
import DocumentInfo from './material/document/PageInfo';
import LookUpIndex from './material/LookUp/Index';
// 资料借用申请
import BorrowAdd from './material/borrow/PageAdd';
import BorrowMine from './material/borrow/PageMine';
import BorrowWatch from './material/borrow/PageWatch';
import BorrowOpen from './material/borrow/PageInfo';
// 资料归还
import ReturnMine from './material/return/PageMine';
import ReturnWatch from './material/return/PageWatch';
import ReturnManage from './material/return/PageManage';

// 资料续证
import RenewalMine from './material/renewal/PageMine';
import RenewalWatch from './material/renewal/PageWatch';
import RenewalInfo from './material/renewal/PageInfo';

// 用章申请
import SealAdd from './seal/PageAdd';
import SealMine from './seal/PageMine';
import SealWatch from './seal/PageWatch';
import SealOpen from './seal/PageInfo';
import SealCompany from './seal/PageCompany';
import SealIncubator from './seal/PageIncubator';

// 采购申请
import PurchaseAdd from './purchase/PageAdd';
import PurchaseMine from './purchase/PageMine';
import PurchaseWatch from './purchase/PageWatch';
import PurchaseOpen from './purchase/PageInfo';

import AnnouncementIndex from './announcement/Index';
import AnnouncementAdd from './announcement/PageAdd';
import AnnouncementEdit from './announcement/PageEdit';
import AnnouncementOpen from './announcement/PageOpen';

const router = {
  path: 'administrative',
  breadcrumbName: '行政',
  childRoutes: [
    // 资料管理
    {
      path: 'material',
      breadcrumbName: '资料管理',
      indexRoute: { component: MaterialIndex },
      childRoutes: [
        {
          path: 'lookUp',
          component: LookUpIndex,
          breadcrumbName: '查阅资料',
        },
        {
          path: 'add/:uuid',
          component: DocumentAdd,
          breadcrumbName: '资料文档编辑',
        },
        {
          path: 'info/:uuid',
          component: DocumentInfo,
          breadcrumbName: '资料文档详情',
        },
        // 资料借用
        {
          path: 'borrow_manage',
          indexRoute: {
            component: BorrowMine,
          },
          breadcrumbName: '资料借用管理',
          childRoutes: [
            {
              path: 'add',
              component: BorrowAdd,
              breadcrumbName: '资料借用申请',
            },
            {
              path: 'open/:uuid',
              component: BorrowOpen,
              breadcrumbName: '查看资料借用',
            },
          ],
        },
        {
          path: 'borrow_manage_mine',
          component: BorrowMine,
          breadcrumbName: '我的资料借用',
        },
        {
          path: 'borrow_manage_watch',
          component: BorrowWatch,
          breadcrumbName: '资料借用监控',
        },
        // 资料归还
        {
          path: 'return_manage_mine',
          component: ReturnMine,
          breadcrumbName: '我借用的资料归还',
        },
        {
          path: 'return_manage_watch',
          component: ReturnWatch,
          breadcrumbName: '资料归还管理',
        },
        {
          path: 'return_manage_manage',
          component: ReturnManage,
          breadcrumbName: '我的资料归还管理',
        },
        {
          path: 'renewal',
          indexRoute: {
            component: RenewalMine,
          },
          childRoutes: [
            {
              path: 'edit/:uuid',
              component: RenewalInfo,
              breadcrumbName: '编辑',
            },
            {
              path: 'open/:uuid',
              component: RenewalInfo,
              breadcrumbName: '编辑',
            },
          ],
        },
        {
          path: 'renewal_mine',
          component: RenewalMine,
          breadcrumbName: '我的资料续证',
        },
        {
          path: 'renewal_watch',
          component: RenewalWatch,
          breadcrumbName: '资料续证监控',
        },
      ],
    },
    {
      path: 'myMaterial',
      component: MyMaterialIndex,
      breadcrumbName: '我的资料管理',
    },
    // 用章
    {
      path: 's_manage',
      indexRoute: {
        component: SealMine,
      },
      breadcrumbName: '用章管理',
      childRoutes: [
        {
          path: 'add',
          component: SealAdd,
          breadcrumbName: '用章申请',
        },
        {
          path: 'open/:uuid',
          component: SealOpen,
          breadcrumbName: '查看用章',
        },
      ],
    },
    {
      path: 's_manage_mine',
      component: SealMine,
      breadcrumbName: '我的用章',
    },
    {
      path: 's_manage_watch',
      component: SealWatch,
      breadcrumbName: '用章监控',
    },
    {
      path: 's_manage_company',
      component: SealCompany,
      breadcrumbName: '按公司统计',
    },
    {
      path: 's_manage_incubator',
      component: SealIncubator,
      breadcrumbName: '按孵化器统计',
    },
    // 采购
    {
      path: 'purchase_manage',
      indexRoute: {
        component: PurchaseMine,
      },
      breadcrumbName: '采购管理',
      childRoutes: [
        {
          path: 'add',
          component: PurchaseAdd,
          breadcrumbName: '采购申请',
        },
        {
          path: 'open/:uuid',
          component: PurchaseOpen,
          breadcrumbName: '查看采购',
        },
      ],
    },
    {
      path: 'purchase_manage_mine',
      component: PurchaseMine,
      breadcrumbName: '我的采购',
    },
    {
      path: 'purchase_manage_watch',
      component: PurchaseWatch,
      breadcrumbName: '采购监控',
    },
    {
      path: 'announcement',
      indexRoute: {
        component: AnnouncementIndex,
      },
      breadcrumbName: '公告列表',
      childRoutes: [
        {
          path: 'add',
          component: AnnouncementAdd,
          breadcrumbName: '公告新增',
        },
        {
          path: 'open/:uuid',
          component: AnnouncementOpen,
          breadcrumbName: '查看公告',
        },
        {
          path: 'edit/:uuid',
          component: AnnouncementEdit,
          breadcrumbName: '编辑公告',
        },
      ],
    },
  ],
};

export default router;



// WEBPACK FOOTER //
// ./src/components/administrative/router.js